// Page content. Only facts provided by the club (Instagram bio/posts, owner answers) are stated as facts.
// Training topics are general enduro skill areas; final programme is set with the instructor.

export const SERVICE_DETAILS = {
  "enduro-tur": {
    eyebrow: "Motor + ekipman dahil",
    headline: "Motorun yok mu? Sorun değil.",
    intro: "Çekmeköy Ormanları'nın doğal parkurlarında, profesyonel rehberler eşliğinde unutulmaz bir enduro deneyimi. Tesise ait motor, ekipman ve kıyafetlerle güvenle sür.",
    hero: "/ig/ig25c.jpg",
    images: ["/ig/ig26c.jpg", "/ig/ig00.jpg", "/ig/ig14.jpg"],
    facts: [
      { k: "Tur süresi", v: "2 saat" },
      { k: "Dahil", v: "Motor, ekipman ve kıyafetler" },
      { k: "Parkur", v: "Çekmeköy Ormanları" },
      { k: "Şart", v: "Geçerli A, A1 veya A2 ehliyet" },
    ],
    steps: [
      { t: "Yerini ayırt", d: "Tarihi seç, rezervasyon talebini gönder ya da WhatsApp'tan yaz." },
      { t: "Gel, giyin", d: "Motor, ekipman ve kıyafetler hazır. Ehliyetini yanına almayı unutma." },
      { t: "Rehberle sür", d: "Profesyonel rehberler eşliğinde 2 saat boyunca ormanda sür." },
    ],
  },
  egitim: {
    eyebrow: "Adım adım",
    headline: "Enduro'yu parkurda öğren.",
    intro: "İlk kez motora binecek olandan, tekniğini geliştirmek isteyen sürücüye kadar herkes için enduro eğitimi. Seviyeni birlikte belirler, programı ona göre kurarız.",
    hero: "/photos/yokus-tirmanis.jpg",
    images: ["/photos/toz-parkur.jpg", "/photos/tepe-zirve.jpg", "/ig/ig03.jpg"],
  },
  "cocuk-egitim": {
    eyebrow: "Aileler için",
    headline: "Motor sevgisi erken başlar.",
    intro: "Çocuklar için motosiklet eğitimi. Çocuğunuzun yaşı ve seviyesi için bize yazın; size uygun programı birlikte planlayalım.",
    hero: "/ig/ig09.jpg",
    images: ["/ig/ig12.jpg", "/ig/ig04.jpg", "/ig/ig11.jpg"],
    points: [
      { t: "Güvenli başlangıç", d: "Ekipmanı tanıma, denge ve kontrol ile adım adım." },
      { t: "Kulüp ortamı", d: "Doğanın içinde, kulübün samimi atmosferinde." },
      { t: "Ailece gelin", d: "Siz de enduro, tur veya eğitimle aynı gün sürün." },
    ],
  },
};

export const LEVELS = [
  {
    key: "baslangic",
    name: "Başlangıç Seviyesi",
    who: "Hiç enduro sürmemiş olanlar",
    tag: "Önerilen başlangıç",
    topics: ["Motosiklet ve ekipman adaptasyonu", "Denge ve ayakta sürüş", "Temel fren ve gaz kontrolü", "Düşük hızda dönüşler", "Parkuru ve engelleri tanıma"],
  },
  {
    key: "orta",
    name: "Orta Seviye",
    who: "Temel sürüşü bilen sürücüler",
    topics: ["Ayakta fren ve kontrol", "Dar alanda dönüş teknikleri", "Doğru sürüş pozisyonları", "Tırmanış ve iniş teknikleri", "Doğal parkurda uygulamalı sürüş"],
  },
  {
    key: "ileri",
    name: "İleri Seviye",
    who: "Tekniğini geliştirmek isteyen deneyimli sürücüler",
    topics: ["Zorlu engel geçişleri", "İleri viraj ve manevra", "Rampa ve sert iniş kontrolü", "Hız ve ritim yönetimi", "Uzun parkurda serbest sürüş"],
  },
];

export const FAQ = [
  { q: "Enduro tura katılmak için ehliyet gerekli mi?", a: "Evet. Enduro tura katılım için geçerli A, A1 veya A2 sınıfı motosiklet ehliyeti gereklidir." },
  { q: "Motorum ve ekipmanım yok, katılabilir miyim?", a: "Evet. Enduro turda tesise ait motor, ekipman ve kıyafetler dahildir." },
  { q: "Tur ne kadar sürüyor?", a: "Enduro tur süresi 2 saattir. Turlar profesyonel rehberler eşliğinde Çekmeköy Ormanları'nın doğal parkurlarında yapılır." },
  { q: "Hiç enduro sürmedim, eğitim alabilir miyim?", a: "Elbette. Eğitimlerimiz başlangıç seviyesinden ileri seviyeye kadar herkese uygundur; seviyeni birlikte belirleriz." },
  { q: "Çocuklar için eğitim var mı?", a: "Evet, çocuklar için motosiklet eğitimi veriyoruz. Çocuğunuzun yaşı ve seviyesine göre bilgi almak için bize WhatsApp'tan yazın." },
  { q: "Neredesiniz?", a: "Çekmeköy / Ömerli, İstanbul. Konum için İletişim sayfasındaki haritaya bakabilirsiniz." },
  { q: "Nasıl rezervasyon yapabilirim?", a: "Rezervasyon sayfasından hizmeti ve tarihi seçip talebinizi gönderebilir, ya da 0539 260 83 20 numarasından WhatsApp veya telefonla ulaşabilirsiniz." },
];

export const POSTS = [
  {
    slug: "enduroya-baslangic-rehberi",
    cat: "Rehber",
    title: "Enduro'ya Başlangıç Rehberi",
    excerpt: "Enduro'yu ilk kez deneyecekler için: neye ihtiyacın var, ilk gün neler olur, nasıl hazırlanmalısın?",
    img: "/ig/ig02.jpg",
    body: [
      "Enduro; ormanlık alan, toprak, taş ve tırmanış gibi doğal arazilerde yapılan bir motosiklet sporu. Pistte değil, doğanın içinde sürersin; bu yüzden hız kadar denge, kontrol ve sabır da önemlidir.",
      "Başlamak için kendi motorunun olması gerekmez. Enduro tur ya da eğitimle kulübün motor ve ekipmanlarıyla ilk deneyimini yaşayabilir, sporu sevip sevmediğini görebilirsin.",
      "İlk sürüşte en önemli şey acele etmemek. Motoru tanımak, ayakta sürüş pozisyonunu öğrenmek ve fren–gaz dengesini hissetmek ilk adımlardır. Rehber ya da eğitmenin talimatlarını dinlemek hem güvenliğin hem de keyfin anahtarıdır.",
      "Yanına rahat kıyafetler, bol su ve iyi bir motivasyon al. Enduro tura katılacaksan geçerli A, A1 veya A2 ehliyetini unutma.",
    ],
  },
  {
    slug: "enduro-ekipmani-secimi",
    cat: "Ekipman",
    title: "Enduro Ekipmanı: Kask, Bot ve Koruyucular",
    excerpt: "Arazide güvenli sürüş için temel ekipmanlar ve her birinin neden önemli olduğu.",
    img: "/ig/ig03.jpg",
    body: [
      "Enduro'da ekipman bir aksesuar değil, güvenliğin temelidir. Arazide düşmek sporun doğal bir parçasıdır; doğru ekipman bu anları sıradan bir tecrübeye dönüştürür.",
      "Kask: Kafa ve yüzü korur; arazi tipi, çeneli bir kask ve gözlük ile kullanılmalıdır. Bot: Ayak bileği ve kaval kemiğini korur, motor üzerinde kontrolü artırır.",
      "Gövde ve dirsek–diz koruyucuları darbelere karşı korur. Eldiven ise hem tutuşu iyileştirir hem de elleri dallar ve taşlardan korur.",
      "Kendi ekipmanın yoksa endişelenme: FX Motor Sporları enduro turunda motor, ekipman ve kıyafetler dahildir.",
    ],
  },
  {
    slug: "parkurda-guvenlik-kurallari",
    cat: "Güvenlik",
    title: "Parkurda Güvenlik: Temel Kurallar",
    excerpt: "Doğal parkurda güvenli ve keyifli bir sürüş için uyulması gereken temel kurallar.",
    img: "/ig/ig26c.jpg",
    body: [
      "Parkura çıkmadan önce ekipmanının tam olduğundan emin ol. Kask, gözlük, bot, eldiven ve koruyucular olmadan sürüşe başlama.",
      "Rehberin ya da eğitmenin önünden gitme, belirtilen parkurun dışına çıkma. Grup sürüşünde öndeki ile güvenli mesafeni koru.",
      "Seviyenin üzerindeki engellere zorlama. Yorulduğunda mola ver ve su iç; yorgunluk arazide en büyük risklerden biridir.",
      "Doğaya saygı göster: parkuru temiz bırak, ormanı ve diğer sürücüleri koru. Güvenli sürüş herkesin keyfidir.",
    ],
  },
];

export const GALLERY = [
  "/photos/grup-ziplama.jpg", "/photos/cam-ziplama.jpg", "/photos/tepe-zirve.jpg", "/photos/yokus-tirmanis.jpg", "/photos/toz-parkur.jpg",
  "/photos/gun-batimi.jpg", "/photos/inis-toz.jpg", "/photos/profil.jpg", "/photos/arka-tirmanis.jpg", "/photos/ay-yamac.jpg", "/photos/cam-grup.jpg", "/photos/yan-surus.jpg", "/photos/karsidan.jpg", "/photos/on-teker.jpg",
  ...[
  "ig00", "ig02", "ig18", "ig25c", "ig04", "ig11", "ig24c", "ig09", "ig26c", "ig14", "ig27c",
  "ig08", "ig03", "ig12", "ig05", "ig15", "ig10", "ig13",
].map((n) => `/ig/${n}.jpg`)];

export const NEWS = [
  {
    id: "fatih-coskun-sky-adventure-inegol",
    date: "1 Kasım 2026",
    tag: "Yarış",
    title: "Fatih Coşkun, Sky Adventure İnegöl'de birinci!",
    category: "Tek Silindir / 150cc - 450cc",
    text: "Kulübümüzün sporcusu Fatih Coşkun, 1 Kasım 2026'da İnegöl'de koşulan Sky Adventure Race yarışında Tek Silindir / 150cc - 450cc kategorisinde 1.lik kazandı. Tebrikler Fatih, FX ailesi seninle gurur duyuyor!",
    img: "/news/fatih-podyum.jpg",
    alt: "Fatih Coşkun Sky Adventure Race İnegöl podyumunda birinci basamakta",
    gallery: [
      { src: "/news/fatih-paddock.jpg", alt: "Fatih Coşkun 14 numaralı FX Motors motosikletiyle" },
      { src: "/news/fatih-start.jpg", alt: "Fatih Coşkun Sky Race Test 1 startında" },
    ],
    link: "https://skyadventure.org/tr/Home/Riders",
    linkLabel: "Sky Adventure Race",
  },
];

// Instagram reels, downloaded and compressed into /public/reels (poster = Instagram cover)
export const REELS = [
  { id: "fx-parkur", label: "FX Parkur", title: "FX Motors — Çekmeköy Motor Sporları parkuru", url: "https://www.instagram.com/fxmotorsporlari/" },
  { id: "DaHogi7N7Of", label: "Enduro'ya başla", title: "Bir çoğumuzun yol motosikleti var fakat iş Enduro'ya gelince nasıl yapsak diye soruluyordu" },
  { id: "DcF3vRJtSC6", label: "Rampa", title: "WSBK yarışçısı Bahattin Sofuoğlu bu rampayı çıkabilecek mi?" },
  { id: "Dd3cbJKj-ej", label: "Antrenman", title: "Antrenmanlarda kendine yaptığın yatırımın gücü" },
  { id: "De0Crhkt3Zt", label: "İlk gün", title: "Tanıştığın ilk gün nasıl geçti?" },
  { id: "DHbmBy0sj1k", label: "Sesler", title: "Kafamdaki sesler" },
  { id: "DcrAvJcNTEI", label: "Uçuş", title: "Kalkışa hazır" },
  { id: "DbyMby6NW-z", label: "Abartma", title: "Yakın arkadaşlarım yaptığı şeyleri abartma şeklim" },
  { id: "DatRmqWNYuM", label: "Selam", title: "Aslında selamsız başlayamam" },
  { id: "DaKwrlBNdkr", label: "Sudan ucuz", title: "Sudan ucuz" },
].map((r) => ({ ...r, video: `/reels/${r.id}.mp4`, poster: `/reels/${r.id}.jpg`, url: r.url || `https://www.instagram.com/reel/${r.id}/` }));
